<div class="modal-vehicle-usage-check p-4">
    <div class="modal-gs-header d-flex justify-content-between align-items-center mb-2">
        <h4 class="mb-0">{{'VEHICLE_USAGE_CHECK.TITLE' | translate}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.hide()"></button>
    </div>

    <div class="py-3">
        @if (loading) {
            <div class="text-center py-4">
                <div class="spinner-border text-gs-primary" role="status">
                    <span class="visually-hidden">{{'LOADING' | translate}}</span>
                </div>
            </div>
        } @else if (hasConflicts || hasBookingConflicts) {
            <div class="alert custom-alert-warning mb-3">
                <div class="d-flex align-items-center">
                    <i class="bi bi-exclamation-triangle-fill me-2"></i>
                    <span>{{'VEHICLE_USAGE_CHECK.CONFLICTS_FOUND' | translate}}</span>
                </div>
            </div>
            
            @if (hasConflicts) {
                <div class="vehicle-usages-list mb-4">
                    <h5 class="mb-3">{{'VEHICLE_USAGE_CHECK.USAGE_LIST' | translate}}:</h5>
                    @for (usage of vehicleUsages; track usage.id) {
                        <div class="usage-item p-3 mb-2 border rounded">
                            <div>
                                <strong>{{'USER' | translate}}:</strong> {{usage.user?.displayName}}
                            </div>
                            <div>
                                <strong>{{'VEHICLE' | translate}}:</strong> {{usage.vehicle?.displayName}}
                            </div>
                            <div>
                                <strong>{{'START_DATE' | translate}}:</strong> {{usage.startDate | date: 'dd-MM-yyyy - HH:mm'}}
                            </div>
                            <div>
                                <strong>{{'END_DATE' | translate}}:</strong> {{usage.endDate | date: 'dd-MM-yyyy - HH:mm'}}
                            </div>
                        </div>
                    }
                </div>
            }
            
            @if (hasBookingConflicts) {
                <div class="booking-list mb-4">
                    <h5 class="mb-3">{{'VEHICLE_USAGE_CHECK.BOOKING_LIST' | translate}}:</h5>
                    @for (booking of bookings; track booking.id) {
                        <div class="booking-item p-3 mb-2 border rounded">
                            <div class="d-flex justify-content-between">
                                <strong>{{booking.title}}</strong>
                                <span class="badge bg-gs-primary text-white">{{booking.status}}</span>
                            </div>
                            <div>
                                <strong>{{'USER' | translate}}:</strong> {{booking.user?.displayName}}
                            </div>
                            <div>
                                <strong>{{'VEHICLE' | translate}}:</strong> {{booking.vehicle?.displayName}}
                            </div>

                            <div class="row">
                                <div class="col-md-6">
                                    <strong>{{'START_DATE' | translate}}:</strong> {{booking.startDate | date: 'dd-MM-yyyy - HH:mm'}}
                                </div>
                                <div class="col-md-6">
                                    <strong>{{'END_DATE' | translate}}:</strong> {{booking.endDate | date: 'dd-MM-yyyy - HH:mm'}}
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
            
            <div class="alert custom-alert-info mt-3">
                <div class="d-flex align-items-center">
                    <i class="bi bi-info-circle-fill me-2"></i>
                    <span>{{'VEHICLE_USAGE_CHECK.CONFIRM_QUESTION' | translate}}</span>
                </div>
            </div>
        } @else {
            <div class="alert custom-alert-success">
                <div class="d-flex align-items-center">
                    <i class="bi bi-check-circle-fill me-2"></i>
                    <span>{{'VEHICLE_USAGE_CHECK.NO_CONFLICTS' | translate}}</span>
                </div>
            </div>
        }
    </div>

    <div class="modal-gs-footer d-flex justify-content-end gap-2">
        <button type="button" class="btn-gs-secondary" (click)="cancel()">
            {{'ACTIONS.CANCEL' | translate}}
        </button>

        <button type="button" class="btn-gs-primary" (click)="continueAnyway()">
            {{'ACTIONS.CONFIRM' | translate}}
        </button>
    </div>
</div> 